import { Button, FileStatus, H2, IconDeleteCircle, Input, SectionContainer } from "@touche-lts/panel-ui/dist"
import { useRootStore } from "mobx-stores/store-provider"
import { observer } from 'mobx-react-lite'
import styles from './image-gallery.module.scss'
import { DropImages, ImagePreview } from "components"
import AvatarEditor from 'react-avatar-editor'
import { useEffect } from "react"
import { ImageTypeDimentions as ImageDimetion } from "models/image-type-dimentions"
import { useParams } from "react-router"
import { useGetIsResponsiveScreen } from "hooks/custom-hooks"

const GalleryDepartmentPageComponent = () => {

    const {
        departmentsStore: {
            departmentStore,
            setStoreProps,
            onSuspendDepartmentClick,
            getDepartmentById,
            resetStore
        },
        imagesStore: {
            squareImageLink,
            backgroundImageLink,
            getCropSquareActive,
            getCropBackgroundActive,
            setSquareActive,
            setBackgroundActive,
            setSqureCropEdit,
            setBackgroundCropEdit,
            getPositionSquare,
            getPositionBackground,
            getScaleSquare,
            getScaleBackground,
            setPositionSqure,
            setScaleSqure,
            setPositionBackground,
            setScaleBackground,
            removeSqureImage,
            removeBackgroundImage,
            clearStore
        }
    } = useRootStore()
    const params = useParams();
    const { departmentId } = useParams<{ departmentId: string }>();
    useEffect(() => {
        resetStore()
        if (departmentId) {
            getDepartmentById(departmentId)
        }
    }, [departmentId, getDepartmentById, resetStore])

    useEffect(() => {
        clearStore()

        const departmentsSquareInfo = departmentStore?.squareCrop;
        if (!!departmentsSquareInfo) {
            setSqureCropEdit(departmentsSquareInfo)
        }
        const departmentsBackgroundInfo = departmentStore?.backgroundCrop;
        if (!!departmentsBackgroundInfo) {
            setBackgroundCropEdit(departmentsBackgroundInfo)
        }

        return () => {
            clearStore()
        }
    }, [departmentStore?.squareCrop, departmentStore?.backgroundCrop, setSqureCropEdit, setBackgroundCropEdit, clearStore, departmentId, getDepartmentById])

    const {isResponsive:isLaptop} = useGetIsResponsiveScreen("(max-width:1024px)")

    return (
        <SectionContainer
            extraPaddingBottom
        >
            <Input
                colorPreset='dark'
                className={styles.departmentName}
                placeholder='Department name'
                value={departmentStore?.name}
                onChange={name => setStoreProps({ name })}
            />
            <H2 className='p-3'>
                Department Gallery
            </H2>
            <div className={styles.squareBackgroundCrop}>
                <div>
                    <p>Square crop</p>
                    {squareImageLink ? (
                        <>
                            {getCropSquareActive ? (
                                <div className='d-flex flex-column'>
                                    <AvatarEditor
                                        width={ImageDimetion.SQUARE_WIDTH}
                                        height={ImageDimetion.SQUARE_HEIGHT}
                                        border={1}
                                        scale={getScaleSquare}
                                        position={getPositionSquare}
                                        onPositionChange={(ev) => setPositionSqure(ev)}
                                        image={squareImageLink}
                                    />
                                    <input
                                        name="scale"
                                        type="range"
                                        onChange={(ev) => setScaleSqure(ev.target.value as any)}
                                        value={getScaleSquare}
                                        min="1"
                                        max="3"
                                        step="0.01"
                                        defaultValue="1"
                                        className="py-2"
                                    />
                                    <Button onClick={() => setSquareActive(false)}>Crop Square</Button>
                                </div>
                            ) : (
                                <ImagePreview
                                    removeCropping={() => console.log('remove')}
                                    removeItem={removeSqureImage}
                                    status={FileStatus.UPLOADING}
                                    width={ImageDimetion.SQUARE_WIDTH}
                                    height={ImageDimetion.SQUARE_HEIGHT}
                                    isSquare={true}
                                    openImageEditor={() => setSquareActive(true)}
                                />
                            )}
                        </>
                    ) : (
                        <DropImages
                            width={ImageDimetion.SQUARE_WIDTH}
                            height={ImageDimetion.SQUARE_HEIGHT}
                            square
                        />
                    )}
                </div>
                <div>
                    <p>Background crop</p>
                    {backgroundImageLink ? (
                        <>
                            {getCropBackgroundActive ? (
                                <div className='d-flex flex-column'>
                                    <AvatarEditor
                                        width={!isLaptop ? ImageDimetion.BACKGROUND_WIDTH : '100%'}
                                        height={ImageDimetion.BACKGROUND_HEIGHT}
                                        border={1}
                                        scale={getScaleBackground}
                                        position={getPositionBackground}
                                        onPositionChange={(ev) => setPositionBackground(ev)}
                                        image={backgroundImageLink}
                                    />
                                    <input
                                        name="scale"
                                        type="range"
                                        onChange={(ev) => setScaleBackground(ev.target.value as any)}
                                        value={getScaleBackground}
                                        min="1"
                                        max="3"
                                        step="0.01"
                                        defaultValue="1"
                                        className="py-2"
                                    />
                                    <Button onClick={() => setBackgroundActive(false)}>Crop Background</Button>
                                </div>
                            ) : (
                                <ImagePreview
                                    removeCropping={() => console.log('remove')}
                                    removeItem={removeBackgroundImage}
                                    status={FileStatus.UPLOADING}
                                    width={!isLaptop ? ImageDimetion.BACKGROUND_WIDTH : ImageDimetion.SQUARE_WIDTH}
                                    height={ImageDimetion.BACKGROUND_HEIGHT}
                                    isSquare={false}
                                    openImageEditor={() => setBackgroundActive(true)}
                                />
                            )}
                        </>
                    ) : (
                        <DropImages
                            width={!isLaptop ? ImageDimetion.BACKGROUND_WIDTH : '100%'}
                            height={ImageDimetion.BACKGROUND_HEIGHT}
                            square={false}
                        />
                    )}
                </div>
            </div>
            {Object.keys(params).length !== 0 && (
                <Button
                    preset='link'
                    className={styles.suspendDepartment}
                    title='Suspend department'
                    onClick={() => onSuspendDepartmentClick(departmentStore)}
                >
                    <IconDeleteCircle color="red" />
                    Suspend department
                </Button>
            )}

        </SectionContainer>
    )
},

    GalleryDepartmentsPage = observer(GalleryDepartmentPageComponent)
export { GalleryDepartmentsPage }
